import { render, staticRenderFns } from "./forSearch.vue?vue&type=template&id=bc0e3b76&"
import script from "./forSearch.vue?vue&type=script&lang=js&"
export * from "./forSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports